import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b22dfba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "specifications-container"
}
const _hoisted_2 = { class: "same-products-block" }
const _hoisted_3 = { class: "availability-block" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: /*#__PURE__*/_normalizeClass('total-price')
}
const _hoisted_7 = {
  key: 4,
  class: /*#__PURE__*/_normalizeClass('total-price')
}
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FieldValue = _resolveComponent("FieldValue")!
  const _component_FormFieldUrlAliasInput = _resolveComponent("FormFieldUrlAliasInput")!
  const _component_FormFieldFileInput = _resolveComponent("FormFieldFileInput")!
  const _component_FormFieldRichTextInput = _resolveComponent("FormFieldRichTextInput")!
  const _component_DynamicField = _resolveComponent("DynamicField")!
  const _component_FormFieldMultiSelect = _resolveComponent("FormFieldMultiSelect")!
  const _component_FormFieldCheckbox = _resolveComponent("FormFieldCheckbox")!
  const _component_ExtendedPrice = _resolveComponent("ExtendedPrice")!
  const _component_SeoFieldGroup = _resolveComponent("SeoFieldGroup")!
  const _component_FormFooter = _resolveComponent("FormFooter")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    "tab-id": _ctx.selectedTabId,
    "onUpdate:tab-id": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.selectedTabId) = $event)),
    "active-tab": _ctx.selectedTabId,
    "onUpdate:active-tab": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.selectedTabId) = $event)),
    title: _ctx.pageTitle,
    "is-content-loading": _ctx.isContentLoading,
    "header-buttons": _ctx.headerButtonList,
    tabs: _ctx.isCreation ? [] : _ctx.tabList
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_FormFooter, {
        "back-href": _ctx.backButtonUrl,
        "is-submitting": _ctx.isSubmitting,
        "is-creation": _ctx.isCreation,
        "can-create-another": _ctx.isCreation,
        onSubmit: _ctx.submitForm
      }, null, 8, ["back-href", "is-submitting", "is-creation", "can-create-another", "onSubmit"])
    ]),
    default: _withCtx(() => [
      (_ctx.isCreation)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            novalidate: "",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_FormFieldComboBox, {
              value: _ctx.values.productType,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.productType) = $event)),
              clearable: true,
              label: "Тип товара",
              error: _ctx.errors.productType,
              name: "productType",
              options: _ctx.productTypeOptionList
            }, null, 8, ["value", "error", "options"]),
            _createVNode(_component_FormFieldComboBox, {
              value: _ctx.values.category,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.category) = $event)),
              label: "Базовая категория",
              error: _ctx.errors.category,
              clearable: true,
              name: "category",
              options: _ctx.categoryOptionList
            }, null, 8, ["value", "error", "options"]),
            _createVNode(_component_FormFieldComboBox, {
              value: _ctx.values.brand,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.brand) = $event)),
              clearable: true,
              label: "Производитель",
              error: _ctx.errors.brand,
              name: "brand",
              options: _ctx.brandOptionList
            }, null, 8, ["value", "error", "options"]),
            _createVNode(_component_FormField, {
              value: _ctx.values.title,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.title) = $event)),
              name: "title",
              error: _ctx.errors.title,
              label: "Название"
            }, null, 8, ["value", "error"]),
            _createVNode(_component_FormField, {
              value: _ctx.values.subtitle,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.subtitle) = $event)),
              name: "subtitle",
              error: _ctx.errors.subtitle,
              label: "Подзаголовок"
            }, null, 8, ["value", "error"])
          ], 32))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            novalidate: "",
            onSubmit: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_ctx.selectedTabId === 'common')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.product && _ctx.product.productType)
                    ? (_openBlock(), _createBlock(_component_FieldValue, {
                        key: 0,
                        label: "Тип товара",
                        type: "text",
                        value: _ctx.product.productType.name
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (_ctx.product && _ctx.product.basisProduct)
                    ? (_openBlock(), _createBlock(_component_FieldValue, {
                        key: 1,
                        label: "Базовый товар",
                        type: "link",
                        value: _ctx.product.basisProduct.name,
                        src: 
            _ctx.getBasisProductFormUrl({
              productId: _ctx.product.basisProduct.id,
            })
          
                      }, null, 8, ["value", "src"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_FormFieldComboBox, {
                    value: _ctx.values.category,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.values.category) = $event)),
                    label: "Базовая категория",
                    error: _ctx.errors.category,
                    clearable: true,
                    name: "category",
                    options: _ctx.categoryOptionList
                  }, null, 8, ["value", "error", "options"]),
                  _createVNode(_component_FormFieldComboBox, {
                    value: _ctx.values.brand,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.values.brand) = $event)),
                    clearable: true,
                    label: "Производитель",
                    error: _ctx.errors.brand,
                    name: "brand",
                    options: _ctx.brandOptionList
                  }, null, 8, ["value", "error", "options"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.title,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.values.title) = $event)),
                    name: "title",
                    error: _ctx.errors.title,
                    label: "Название"
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.subtitle,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.values.subtitle) = $event)),
                    name: "subtitle",
                    error: _ctx.errors.subtitle,
                    label: "Подзаголовок"
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormFieldUrlAliasInput, {
                    id: "urlAlias",
                    value: _ctx.values.urlAlias,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.values.urlAlias) = $event)),
                    name: "urlAlias",
                    label: "URL",
                    "url-template": _ctx.pagePath,
                    error: _ctx.errors.urlAlias
                  }, null, 8, ["value", "url-template", "error"]),
                  _createVNode(_component_FormFieldFileInput, {
                    value: _ctx.values.image,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.values.image) = $event)),
                    label: "Картинка",
                    name: "image",
                    "file-type": "image"
                  }, null, 8, ["value"]),
                  _createVNode(_component_FormFieldRichTextInput, {
                    value: _ctx.values.content,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.values.content) = $event)),
                    name: "content",
                    label: "Описание товара",
                    error: _ctx.errors.content
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormFieldRichTextInput, {
                    value: _ctx.values.contentPrice,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.values.contentPrice) = $event)),
                    name: "contentPrice",
                    label: "Текст / Баннер под ценой",
                    error: _ctx.errors.contentPrice
                  }, null, 8, ["value", "error"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'media')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_FormFieldFileInput, {
                    value: _ctx.values.gallery,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.values.gallery) = $event)),
                    name: "gallery",
                    error: _ctx.errors.gallery,
                    label: "Галерея",
                    "file-type": "image",
                    "with-captions": true,
                    multiple: ""
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormFieldFileInput, {
                    value: _ctx.values.schemaImage,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.values.schemaImage) = $event)),
                    label: "Схема",
                    name: "schemaImage",
                    "file-type": "image"
                  }, null, 8, ["value"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.youtubeVideo,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.values.youtubeVideo) = $event)),
                    name: "youtubeVideo",
                    error: _ctx.errors.youtubeVideo,
                    label: "Youtube Видео"
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormFieldFileInput, {
                    value: _ctx.values.video,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.values.video) = $event)),
                    label: "Видео",
                    name: "video",
                    accept: '.mp4'
                  }, null, 8, ["value", "accept"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'specifications')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productTypeValues, (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.config.name
                    }, [
                      _createVNode(_component_DynamicField, { field: field }, null, 8, ["field"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'connections')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_FormFieldComboBox, {
                    value: _ctx.values.category,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.values.category) = $event)),
                    label: "Базовая категория",
                    error: _ctx.errors.category,
                    clearable: true,
                    name: "category",
                    options: _ctx.categoryOptionList
                  }, null, 8, ["value", "error", "options"]),
                  _createVNode(_component_FormFieldComboBox, {
                    value: _ctx.values.collection,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.values.collection) = $event)),
                    label: "Коллекция",
                    error: _ctx.errors.collection,
                    clearable: true,
                    name: "collection",
                    options: _ctx.collectionSearchListOption
                  }, null, 8, ["value", "error", "options"]),
                  _createVNode(_component_FormFieldMultiSelect, {
                    "selected-options": _ctx.values.productGroups,
                    "onUpdate:selected-options": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.values.productGroups) = $event)),
                    name: "productGroups",
                    label: "Группы товаров:",
                    options: _ctx.productGroupListOption,
                    error: _ctx.errors.productGroups
                  }, null, 8, ["selected-options", "options", "error"]),
                  _createVNode(_component_FormFieldMultiSelect, {
                    "selected-options": _ctx.values.specialOffers,
                    "onUpdate:selected-options": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.values.specialOffers) = $event)),
                    name: "specialOffers",
                    label: "Спецпредложения:",
                    options: _ctx.specialListOption,
                    error: _ctx.errors.specialOffers
                  }, null, 8, ["selected-options", "options", "error"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_DynamicField, {
                      field: _ctx.inputsSameProductField,
                      "is-label-hidden": false
                    }, null, 8, ["field"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'price')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_FormFieldComboBox, {
                      value: _ctx.values.availability,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.values.availability) = $event)),
                      label: "Наличие",
                      name: "availability",
                      clearable: true,
                      error: _ctx.errors.availability,
                      options: _ctx.availabilityOptionList,
                      class: "availability"
                    }, null, 8, ["value", "error", "options"]),
                    (
              _ctx.values.availability && _ctx.values.availability.value === 'ON_REQUEST'
            )
                      ? (_openBlock(), _createBlock(_component_FormField, {
                          key: 0,
                          value: _ctx.values.waitingDays,
                          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.values.waitingDays) = $event)),
                          type: "number",
                          label: "Кол-во дней ожидания",
                          error: _ctx.errors.waitingDays,
                          name: "waitingDays",
                          class: "availability-days"
                        }, null, 8, ["value", "error"]))
                      : _createCommentVNode("", true),
                    (
              _ctx.values.availability && _ctx.values.availability.value === 'AVAILABLE'
            )
                      ? (_openBlock(), _createBlock(_component_FormField, {
                          key: 1,
                          value: _ctx.values.availableQuantity,
                          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.values.availableQuantity) = $event)),
                          type: "number",
                          label: "Количество",
                          error: _ctx.errors.availableQuantity,
                          name: "availableQuantity",
                          class: "availability-quantity"
                        }, null, 8, ["value", "error"]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.values.priceMultiple)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_FormField, {
                          value: _ctx.values.price,
                          "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.values.price) = $event)),
                          type: "number",
                          label: "Цена",
                          error: _ctx.errors.price,
                          name: "price"
                        }, null, 8, ["value", "error"]),
                        _createVNode(_component_FormFieldCheckbox, {
                          checked: _ctx.values.onDiscount,
                          "onUpdate:checked": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.values.onDiscount) = $event)),
                          label: "Включить скидку",
                          error: _ctx.errors.onDiscount,
                          name: "onDiscount"
                        }, null, 8, ["checked", "error"]),
                        (_ctx.values.onDiscount)
                          ? (_openBlock(), _createBlock(_component_FormFieldComboBox, {
                              key: 0,
                              value: _ctx.values.discountType,
                              "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.values.discountType) = $event)),
                              clearable: true,
                              label: "Тип скидки",
                              error: _ctx.errors.discountType,
                              name: "discountType",
                              options: _ctx.discountTypeOption,
                              onChange: _ctx.resetDiscountValue
                            }, null, 8, ["value", "error", "options", "onChange"]))
                          : _createCommentVNode("", true),
                        (_ctx.values.onDiscount)
                          ? (_openBlock(), _createBlock(_component_FormField, {
                              key: 1,
                              id: "discountValue",
                              value: _ctx.values.discountValue,
                              "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.values.discountValue) = $event)),
                              type: "number",
                              label: _ctx.values.discountType ? _ctx.values.discountType.label : '...',
                              error: _ctx.errors.discountValue,
                              name: "discountValue"
                            }, null, 8, ["value", "label", "error"]))
                          : _createCommentVNode("", true),
                        (
              _ctx.values.discountType &&
              _ctx.values.onDiscount &&
              (_ctx.values.discountType.value === 'PERCENT' ||
                _ctx.values.discountType.value === 'VALUE')
            )
                          ? (_openBlock(), _createElementBlock("label", _hoisted_5, " Итоговая цена "))
                          : _createCommentVNode("", true),
                        (
              _ctx.values.discountType && _ctx.values.discountType.value === 'PERCENT'
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.getDiscountPricePercent(_ctx.values.price, _ctx.values.discountValue)) + " руб. ", 1))
                          : _createCommentVNode("", true),
                        (
              _ctx.values.discountType &&
              _ctx.values.onDiscount &&
              _ctx.values.discountType.value === 'VALUE'
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.getDiscountPriceValue(_ctx.values.price, _ctx.values.discountValue)) + " руб. ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_FormFieldCheckbox, {
                    checked: _ctx.values.priceMultiple,
                    "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.values.priceMultiple) = $event)),
                    label: "Несколько цен",
                    error: _ctx.errors.priceMultiple,
                    name: "priceMultiple"
                  }, null, 8, ["checked", "error"]),
                  (_ctx.values.priceMultiple)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_FormField, {
                          value: _ctx.values.priceMultipleLabel,
                          "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.values.priceMultipleLabel) = $event)),
                          name: "priceMultipleLabel",
                          label: "Название параметра",
                          error: _ctx.errors.priceMultipleLabel
                        }, null, 8, ["value", "error"]),
                        _createVNode(_component_ExtendedPrice, { values: _ctx.values }, null, 8, ["values"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'seo')
              ? (_openBlock(), _createBlock(_component_SeoFieldGroup, {
                  key: 5,
                  title: _ctx.values.pageTitle,
                  description: _ctx.values.pageDescription,
                  image: _ctx.values.openGraphImage,
                  onChange: _ctx.handleSearchEngineOptimization
                }, null, 8, ["title", "description", "image", "onChange"]))
              : _createCommentVNode("", true)
          ], 32))
    ]),
    _: 1
  }, 8, ["tab-id", "active-tab", "title", "is-content-loading", "header-buttons", "tabs"]))
}